"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BannerText = exports.BannerContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Typography_1 = __importDefault(require("../UI/Typography"));
exports.BannerContainer = styled_components_1.default.div `
  position: sticky;
  flex-shrink: 0;
  top: 0;
  display: flex;
  justify-content: center;
  padding: ${props => props.theme.spacing.s2}px;
  width: 100%;
  z-index: ${props => props.theme.attributes.zIndex.expressBanner};
  background-color: ${props => props.theme.palette.BLUE_100};
  pointer-events: auto;
`;
exports.BannerText = (0, styled_components_1.default)(Typography_1.default) `
  margin-left: ${props => props.theme.spacing.s2}px;
  color: ${props => props.theme.palette.BW_100};
  a {
    color: ${props => props.theme.palette.BW_100};
  }

  p {
    margin: 0;
  }
`;
exports.default = {
    BannerContainer: exports.BannerContainer,
    BannerText: exports.BannerText
};
